// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-bar {
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 0.375rem;
  margin-top: 20px;
}
.action-bar input[type=checkbox] {
  margin-right: 10px;
  cursor: pointer;
}
.action-bar button {
  border: none;
  background-color: transparent;
  margin-right: 10px;
}
.action-bar button:last-child {
  margin-right: 0;
}
.action-bar button .actionbar-icons {
  width: 18px;
  height: 18px;
  cursor: pointer;
  color: #686868;
}`, "",{"version":3,"sources":["webpack://./src/components/ActionBar/ActionBar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EAEA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAAF;AAEE;EACE,kBAAA;EACA,eAAA;AAAJ;AAGE;EACE,YAAA;EACA,6BAAA;EACA,kBAAA;AADJ;AAGI;EACE,eAAA;AADN;AAII;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAFN","sourcesContent":[".action-bar {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  // box-shadow: 0 1px 3px var(--boxshadow-color);\n  border: 1px solid #ddd;\n  border-radius: 0.375rem;\n  margin-top: 20px;\n\n  input[type=\"checkbox\"] {\n    margin-right: 10px;\n    cursor: pointer;\n  }\n\n  button {\n    border: none;\n    background-color: transparent;\n    margin-right: 10px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    .actionbar-icons {\n      width: 18px;\n      height: 18px;\n      cursor: pointer;\n      color: #686868;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
